import React, { useEffect, useState } from "react";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import { WebcamCard } from "../components/home/WebcamCard";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { RecordingButtons } from "../components/home/RecordingButtons";
import { Button } from "@mui/material";
import { VideoTimer } from "../api/VideoTimer";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import { useVideo } from "../api/VideoProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { CameraPermissionsPrompt } from "../components/home/CameraPermissionsPrompt";
import { pStatus } from "../utils/parameters";
//import Switch from "react-switch";
import { useSnackbar } from "notistack";
//import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
//import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";
import UndoIcon from "@mui/icons-material/Undo";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDataProvider } from "../api/DataProvider";  
import { pDataProvider } from "../utils/parameters";
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsRecordVariant } from "../components/tour/TourConfig";
import { useCommProvider } from "../api/CommProvider";
import { WebcamSelection } from "../components/home/WebcamSelection";

import { Dialog } from "@material-ui/core";
import { LoadingDialog } from "../components/dialog/LoadingDialog";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../components/utils/DeviceQueries";

import "../styles/devices/mob_Home.css";
import "../styles/devices/mob_Collaborator.css";

export function RecorderTask() {
  const { t } = useTranslation("global")

  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  /* Sign to collaborate */
  const [sign, setSign] = useState(pDataProvider.new_sign);
  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [switchGalibo, setSwitchGalibo] = useState(true);
  const [switchSide, setSwitchSide] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const { comm_sendCollaboration, comm_sendVideoMoveYourSkeleton } = useCommProvider();
  const { token_id, currentUser } = useDataProvider();
  const { json_data_lemma, json_data_meaning, json_data_glosses } = useDataProvider();

  const [loading, setLoading] = useState(false);
  
  /* MOB - Nav responsiveness */
  const queryMatches = DeviceQueries();

  /* Set initial values every time the Home page is opened */
  useEffect(() => {
    setFaceStatus(pStatus.init);
  }, [setFaceStatus]);

  function handleReturnButton() {

    if (location.src === "/moveYourSkeleton") {
      handleGameMoveYourSkeletonReturn();
    } else {
      handleSwitchReturn();
    }
  }

  /* Send video to server */
  async function send2ServerRecorder() {

    const locationLabels = {
      'lemma': json_data_lemma[location['lemma']]['label'],
      'meaning': json_data_meaning[location['meaning']]['label'],
      'gloss': json_data_glosses[location['gloss']]['label'],
    }

    const videoFile = await saveVideo(mediaBlobUrl);
    
    // console.log('VIDEO_FILE')
    // console.log("🚀 ~ file: Recorder.js:114 ~ send2ServerRecorder ~ videoFile:", videoFile)
    // console.log("🚀 ~ file: Recorder.js:114 ~ send2ServerRecorder ~ mediaBlobUrl:", mediaBlobUrl)
    // console.log("🚀 ~ file: Recorder.js:114 ~ send2ServerRecorder ~ locationLabels:", locationLabels)

    const response = await comm_sendCollaboration(token_id, currentUser, location, locationLabels, videoFile, location.team_id, location.task_id);
    handleSwitchVideoSent(response['_id']);

    setFaceStatus(pStatus.init);
    setSign("");
  }

  function selectSign(sign_id) {
    if (sign_id !== undefined) {
      const gloss_label = json_data_glosses[sign_id][pDataProvider.label];
      setSign(gloss_label)
      enqueueSnackbar("Seleccionado el signo: " + gloss_label, { variant: "info" });
    }else{
      setSign(pDataProvider.new_sign);
      enqueueSnackbar("Seleccionada una nueva variante", { variant: "info" });
    }
  }

  /* Snackbars with info */
  useEffect(() => {
    switch (faceStatus) {
      case pStatus.runTf:
        setSnack({ ...snack, open: true, text: t("sRecordComponent.setFace"), type: "info" });
        break;
      case pStatus.countdown:
        setSnack({ ...snack, open: true, text: t("sRecordComponent.recording"), type: "info" });
        break;
      default:
        break;
    }
    /* eslint-disable-next-line */
  }, [faceStatus]);

  /* Check device & Camera permissions */
  useEffect(() => {
    /* Only check if there are no camera permissions */
    if (!cameraPermissions.cam) {
      /* Status and permissions prompt */
      setCameraPermissions({ ...cameraPermissions, perm: false });
      setFaceStatus(pStatus.error);
      /* Check permissions again */
      checkCameraPermissions()
        .then((r) => {
          setCameraPermissions({ ...cameraPermissions, perm: r, cam: r });
          r ? setFaceStatus(pStatus.init) : setFaceStatus(pStatus.error);
        })
        .catch((e) => setCameraPermissions({ ...cameraPermissions, perm: false, cam: false }));
    }
    // eslint-disable-next-line
  }, []);

  function toggleGalibo() {
    if (switchGalibo) {
      //enqueueSnackbar("Se ha desactivado la detección facial.", { variant: "warning" });
      enqueueSnackbar("Se ha desactivado la ayuda al encuadre.", { variant: "warning" });
    } else {
      //enqueueSnackbar("Se ha activado la detección facial.", { variant: "success" });
      enqueueSnackbar("Se ha activado la ayuda al encuadre.", { variant: "success" });
    }
    setSwitchGalibo((galibo) => !galibo);
  }

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  /* Tour */
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  const location = useLocation();
  useEffect(() => {
    selectSign(location.gloss)
    // console.log("LOCATION", location);
    // console.log(location);
  }, [location]);

  const history = useHistory();
  const handleSwitchReturn = () => {

    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.team_id:", location.team_id)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.task_id:", location.task_id)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.lemma:", location.lemma)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.meaning:", location.meaning)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.gloss:", location.gloss)

    history.push({
      pathname: "/teams",
      team_id: location.team_id,
      task_id: location.task_id,
      lemma: location.lemma,
      meaning: location.meaning,
      gloss: location.gloss,
      video_sent: false
    });
  };

  function handleSwitchVideoSent(record_id) {

    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.team_id:", location.team_id)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.task_id:", location.task_id)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.lemma:", location.lemma)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.meaning:", location.meaning)
    // console.log("🚀 ~ file: RecorderTask.js:222 ~ handleSwitchReturn ~ location.gloss:", location.gloss)

    history.push({
      pathname: "/teams",
      team_id: location.team_id,
      task_id: location.task_id,
      lemma: location.lemma,
      meaning: location.meaning,
      gloss: location.gloss,
      record_id: record_id,
      video_sent: true
    });
  };

  const handleGameMoveYourSkeletonReturn = () => {
    history.push({
      pathname: "/moveYourSkeleton",
      gloss: location.gloss,
      video_user: "",
      counter_repeats_used: location.counter_repeats_used
    });
  };

  const handleGameMoveYourSkeletonVideoSent = (videoUser) => {
    setLoading(false);
    // console.log('handleSwitchGameSkeletonQualityVideoSent', videoUser)
    const history_data = {
      pathname: "/moveYourSkeleton",
      gloss: location.gloss,
      video_user: videoUser['filename'],
      counter_repeats_used: location.counter_repeats_used,
      score_user: videoUser['report'][9],
    }
    // console.log("🚀 ~ file: Recorder.js:250 ~ handleGameMoveYourSkeletonVideoSent ~ history_data:", history_data)


    // history_data = {
    //   pathname: "/moveYourSkeleton",
    //   gloss: location.gloss,
    //   video_user: videoUser['filename'],
    //   counter_repeats_used: location.counter_repeats_used,
    //   score_user: int (videoUser['report'][8] * 100),
    // }
    // console.log("🚀 ~ file: Recorder.js:250 ~ handleGameMoveYourSkeletonVideoSent ~ history_data:", history_data)
    history.push(history_data);
  };

  return (
    <HomeWrapper>
      <Grid className={`sig_Home_MainSectionContainer ${queryMatches.deviceLandscape ? "sig_Home_MSCLandscape" : ""}`} container>
        <Grid item className={`sig_Home_Options sig_Home_Options${switchSide ? "Right" : "Left"}`}>
          {queryMatches.desktop ? (
            <Grid container className="sig_Home_MainSectionOptions">             
              <Button data-tour="tourCam_2b" onClick={handleReturnButton} className="sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode" variant="contained">
                <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
              </Button>
              <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false}  permissions={cameraPermissions.cam} />
              {/* <Tooltip title={t("sTooltip.help_framing")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={() => toggleGalibo()}>
                  {switchGalibo ? <SelectAllIcon className="sig_Home_ChangeOnDarkMode" /> : <DeselectIcon className="sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip> */}
              <Tooltip title={t("sTooltip.show_help")} placement="top" arrow>
                <div data-tour='tourCam_1' className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsRecordVariant, 0)}>
                  <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip>
            </Grid>
          ) : queryMatches.devicePortrait ? (
            <>             
            <Button data-tour="tourCam_2b" onClick={handleReturnButton} className="sig_Collab_Terms_ReturnButton sig_Collab_Terms_ReturnButtonFullWidth sig_Home_ChangeOnDarkMode" variant="contained">
              <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
            </Button>
            </>
          ) : ( 
            <></>
          )}
          <Grid container className={`sig_Home_MainSectionCamera ${queryMatches.deviceLarge ? "sig_Home_MainSectionCamera_LargeDevice" : ""}`}>
            <Grid item>
              <WebcamCard devicePortrait={queryMatches.devicePortrait} setVideo={setMediaBlobUrl} permissions={cameraPermissions.cam} deviceId={deviceId} switchGalibo={switchGalibo}>
                {!cameraPermissions.perm && <CameraPermissionsPrompt />}
              </WebcamCard>
            </Grid>
          </Grid>
          <Grid container className={`sig_Home_MainSectionButtons ${queryMatches.deviceLarge ? "sig_Home_MainSectionButtons_LargeDevice" : ""}`}>
            {queryMatches.desktop ? (
              <>
              <Grid item className="sig_Home_ProgressContainer">
                <VideoTimer />
              </Grid>
              </>
            ) : (
              <Grid container className="sig_Home_MainSectionOptions">
              {queryMatches.deviceLandscape ? (
                <FormControlLabel
                  control={
                    <>
                      <SyncAltIcon className="sig_Home_ChangeOnDarkMode" />
                      <Switch color="primary" onClick={toggleSide} checked={switchSide} />
                    </>
                  }
                />
              ) : (
                <>
                <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false}  permissions={cameraPermissions.cam} />
                </>
              )}         
              <Tooltip title={t("sTooltip.help_framing")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={() => toggleGalibo()}>
                  {switchGalibo ? <SelectAllIcon className="sig_Home_ChangeOnDarkMode" /> : <DeselectIcon className="sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip>
              <Tooltip title={t("sTooltip.show_help")} placement="top" arrow>
                <div data-tour="tourCam_1" className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsRecordVariant, 0)}>
                  <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip>
              </Grid>
            )}
            <Grid item className="sig_Home_ButtonsContainerOuter sig_Home_Variant_ButtonsContainerOuter">
              <RecordingButtons handleSend={send2ServerRecorder} setSelectedSign={true} sign={sign} switchGalibo={switchGalibo}>
                {queryMatches.deviceLandscape ? (
                  <>
                  <Button data-tour="tourCam_2b" onClick={handleReturnButton} className="sig_Collab_Terms_ReturnButton sig_Collab_Terms_ReturnButtonFullWidth sig_Home_ChangeOnDarkMode" variant="contained">
                    <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
                  </Button>
                  <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false}  permissions={cameraPermissions.cam} />
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : queryMatches.devicePortrait ? (
                  <>
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : (<>
                  </>
                  )}
              </RecordingButtons>
            </Grid>
          </Grid>
          <HelpSnackbar snack={snack} setSnack={setSnack} />
        </Grid>
      </Grid>
      <Dialog className="sig_SignModal_Dialog" open={loading} maxWidth="md">
        <LoadingDialog />	
      </Dialog>
    </HomeWrapper>
  );
}
